var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdDirectBackgroundMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 500,
    viewBox: "0 0 335 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3498_2080",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 500
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 500,
    rx: 20,
    fill: "#111111"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3498_2080)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3498_2080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.00001 418.467C-3.00001 369.733 -1.66837 370.133 9.27473 346.044C27.1183 306.765 0.744475 277.762 119.646 346.044C238.547 414.325 45.3144 553.309 20.4239 489.787C9.46826 461.828 -3.00002 467.2 -3.00001 418.467Z",
    fill: "url(#paint0_linear_3498_2080)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3498_2080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.788 215.267C252.174 227.388 209.255 208.791 191.95 175.904C171.289 136.641 213.797 120.19 232.229 73.017C275.804 -38.5038 340.487 75.5044 366.549 97.2674C404.795 129.205 363.844 203.48 308.788 215.267Z",
    fill: "url(#paint1_linear_3498_2080)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3498_2080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.057 148.034C144.746 123.11 162.492 45.5665 230.43 -2.89954C276.627 -35.8565 351.034 -21.3199 361.844 15.4457C372.654 52.2113 385.327 72.0995 329.621 88.478C273.916 104.856 277.048 163.11 209.057 148.034Z",
    fill: "url(#paint2_linear_3498_2080)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3498_2080",
    x: -163,
    y: 145,
    width: 481,
    height: 521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80,
    result: "effect1_foregroundBlur_3498_2080"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3498_2080",
    x: 86.416,
    y: -75.1738,
    width: 395.074,
    height: 394.166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_3498_2080"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3498_2080",
    x: 69.0781,
    y: -121.288,
    width: 402.168,
    height: 371.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_3498_2080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3498_2080",
    x1: 112.655,
    y1: 429.477,
    x2: 85.0331,
    y2: 326.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FE70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3498_2080",
    x1: 372.732,
    y1: 154.006,
    x2: 187.99,
    y2: 140.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FE70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3498_2080",
    x1: 310.74,
    y1: -5.77259,
    x2: 143.801,
    y2: 133.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAFF1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdDirectBackgroundMobile);
export default __webpack_public_path__ + "static/media/AdDirectBackgroundMobile.2a82a7811074d6c437e5b9c647637935.svg";
export { ForwardRef as ReactComponent };